import "./Laundromats.css";
import "./ResponsiveLaundromats.css";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useBetween } from "use-between";
import { getTranslatedText as translate } from "../../Localization/Translation";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import DetailedLaundry from "../DetailedLaundry/DetailedLaundry.js";
import Footer from "../../Footer/Footer";

const LaundryOwners = () => {
  const { locale } = useBetween(useSelector((state) => state.useSharedLang));
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (laundryId) => {
    setShow(true);
  };

  var LaundryOwnersItems = [
    {
      id: 1,
      name: "مغسلة السعودية",
      date: "25/12/2020",
      Address: "عنوان الإقامة",
    },
    {
      id: 2,
      name: "مغسلة السعودية",
      date: "25/12/2020",
      Address: "عنوان الإقامة",
    },
    {
      id: 3,
      name: "مغسلة السعودية",
      date: "25/12/2020",
      Address: "عنوان الإقامة",
    },
    {
      id: 4,
      name: "مغسلة السعودية",
      date: "25/12/2020",
      Address: "عنوان الإقامة",
    },
  ];
  let d = "-1";
  const LaundryOwnersList = LaundryOwnersItems.map((Item, index) => {
    d = Number(d) + 1;
    return (
      <div
        className={
          "LaundryOwners-list animate__animated animate__fadeInLeft animate__delay-" +
          d +
          "s"
        }
        key={Item.id}
        id={Item.id}
      >
        <div className="request-card row" dir="auto">
          <div
            className="col-md-8 request-card-col main-data-request-card-col"
            dir="auto"
          >
            <div className="header-join-req-card">
              <span>
                <i className="fa fa-building" aria-hidden="true"></i>
                {translate("laundry-name", locale)}:
              </span>
              <span>{Item.name}</span>
            </div>
            <div className="date-join-req-card">
              <span>
                <i className="fa fa-calendar" aria-hidden="true"></i>
                {translate("date-of-join", locale)}:
              </span>
              <span>{Item.date}</span>
            </div>
          </div>
          <div className="col-md request-card-col detail-btn-request-card-col">
            <button className="btn btn-primary" onClick={handleShow}>
              {translate("laund-details-btn", locale)}
            </button>
          </div>
        </div>
      </div>
    );
  });
  return (
    // <div className="main-component">
    <div className="LaundryOwners">
      <div className="header-filter-laundries">
        <div className="SearchWasher">
          {/* <!-- Actual search box --> */}
          <div
            className="form-group has-search "
            dir={locale === "EN" || locale === "HN" ? "ltr" : "rtl"}
          >
            <i className="bi bi-search form-control-feedback"></i>
            <input
              type="text"
              className="form-control search-washer-input-placeholder"
              placeholder={translate("Search-box-placeholder", locale)}
            />
          </div>

          {/* <!-- Filter --> */}
          <div className="filter-box-search-washer ">
            <select className="selectFilter" name="filter">
              <option className="optionsMenu" value="rate">
                {translate("choose-city", locale)}
              </option>
              <option className="optionsMenu" value="near">
                {translate("choose-city", locale)}
              </option>
            </select>
            <select className="selectFilter" name="filter">
              <option className="optionsMenu" value="rate">
                {translate("date-filter-new-to-old", locale)}
              </option>
              <option className="optionsMenu" value="near">
                {translate("date-filter-old-to-new", locale)}
              </option>
            </select>
          </div>
        </div>
      </div>

      {LaundryOwnersList}

      <Modal show={show} onHide={handleClose} size="md" dir="auto">
        <Modal.Header className="modal-header">
          {translate("laund-details-btn", locale)}
        </Modal.Header>
        <Modal.Body>
          <DetailedLaundry />
        </Modal.Body>
        <Modal.Footer dir="auto">
          <Button variant="secondary" onClick={handleClose}>
            {translate("modal-close-btn", locale)}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
    // </div>
  );
};

export default LaundryOwners;
